//change columns dynamically
jQuery(document).ready(function ($) {
  $('input[name="show_columns"]').on("change", function () {
    var columns = $(this).val();
    var shopProducts = $(".product-grid");

    // Remove existing grid--*-col-desktop classes and add the new one
    shopProducts
      .removeClass(function (index, className) {
        return (className.match(/grid--\d+-col-desktop/g) || []).join(" ");
      })
      .addClass("grid--" + columns + "-col-desktop");
  });
});

